import {Runner, RunnerInterface} from '../models/runner';
import {RUNS_HUMAN_READABLE} from '../models/waypoint';
import RunProvider from './run';

export default class RenderProvider {
    static instance = null;

    favoriteRunnerContainer: Element;

    favoriteRunnerName: Element;

    favoriteRunnerTitle: Element;

    favoriteRunnerImg: HTMLImageElement;

    favoriteRunnerRun: Element;

    favoriteRunnerStartnumber: Element;

    favoriteRunnerRanks: Element;

    favoriteRunnerRankTotal: Element;

    favoriteRunnerRankAge: Element;

    searchContainer: Element;

    searchToggleButton: Element;

    searchInput: HTMLInputElement;

    searchResults: Element;

    searchFilterRunOptions: NodeListOf<Element>;

    loadingContainer: Element;

    runnerCountdown: Element;

    runnerCountdownHeadline: Element;

    runnerCountdownDays: Element;

    runnerCountdownHours: Element;

    runnerCountdownMins: Element;

    runnerCountdownSecs: Element;

    statisticsSpinnerTemplate: Element;

    statisticsDistanceTemplate: Element;

    statisticsDistance: Element;

    statisticsTime: Element;

    statisticsSpeedTemplate: Element;

    statisticsSpeed: Element;

    statisticsEta: Element;

    statisticsEtaTemplate: Element;

    statisticsEtaSwitch: HTMLButtonElement;

    runnerStatistics: Element;

    passedWaypoints: Element;

    passedWaypointsRowTemplate: Element;

    passedWaypointsBody: Element;

    passedWaypointsTimeSwitch: Element;

    statisticsPaceIndicator: Element;

    mapContainer: Element;

    finishTemplate: HTMLTemplateElement;

    private runProvider: RunProvider;

    static getInstance(): RenderProvider {
        if (!this.instance) {
            this.instance = new RenderProvider();
        }

        return this.instance;
    }

    constructor() {
        this.runProvider = RunProvider.getInstance();

        this.favoriteRunnerContainer = document.querySelector('.js-race-tracking-favorite');
        this.favoriteRunnerName = document.querySelector('.js-race-tracking-favorite-name');
        this.favoriteRunnerTitle = document.querySelector('.js-race-tracking-favorite-title');
        this.favoriteRunnerImg = document.querySelector('.js-race-tracking-favorite-img');
        this.favoriteRunnerRun = document.querySelector('.js-race-tracking-favorite-run');
        this.favoriteRunnerStartnumber = document.querySelector('.js-race-tracking-favorite-startnumber');
        this.favoriteRunnerRanks = document.querySelector('.js-race-tracking-favorite-ranks');
        this.favoriteRunnerRankTotal = document.querySelector('.js-race-tracking-favorite-rank-total');
        this.favoriteRunnerRankAge = document.querySelector('.js-race-tracking-favorite-rank-age');

        this.searchContainer = document.querySelector('.js-runner-search-container');
        this.searchToggleButton = document.querySelector('.js-runner-search-toggle');
        this.searchInput = document.querySelector('.js-runner-search-input');
        this.searchResults = document.querySelector('.js-runner-search-results');
        this.searchFilterRunOptions = document.querySelectorAll('.js-runner-search-run-option');

        this.loadingContainer = document.querySelector('.js-race-tracking-container');
        this.runnerCountdown = document.querySelector('.js-race-tracking-countdown');
        this.runnerCountdownHeadline = document.querySelector('.js-race-tracking-countdown-headline');
        this.runnerCountdownDays = document.querySelector('.js-race-tracking-countdown-days');
        this.runnerCountdownHours = document.querySelector('.js-race-tracking-countdown-hours');
        this.runnerCountdownMins = document.querySelector('.js-race-tracking-countdown-mins');
        this.runnerCountdownSecs = document.querySelector('.js-race-tracking-countdown-secs');

        this.runnerStatistics = document.querySelector('.js-runner-statistics');
        this.statisticsSpinnerTemplate = document.querySelector('.js-runner-statistics-spinner');
        this.statisticsDistanceTemplate = document.querySelector('.js-runner-statistics-distance-template');
        this.statisticsDistance = document.querySelector('.js-runner-statistics-distance');
        this.statisticsSpeedTemplate = document.querySelector('.js-runner-statistics-speed-template');
        this.statisticsSpeed = document.querySelector('.js-runner-statistics-speed');
        this.statisticsTime = document.querySelector('.js-runner-statistics-time');
        this.statisticsEtaTemplate = document.querySelector('.js-runner-statistics-eta-template');
        this.statisticsEta = document.querySelector('.js-runner-statistics-eta');
        this.statisticsEtaSwitch = document.querySelector('.js-runner-statistics-eta-switch');
        this.statisticsPaceIndicator = document.querySelector('.js-runner-statistics-pace-indicator');

        this.passedWaypoints = document.querySelector('.js-runner-passed-waypoints');
        this.passedWaypointsRowTemplate = document.querySelector('.js-runner-passed-waypoints-row-template');
        this.passedWaypointsBody = document.querySelector('.js-runner-passed-waypoints-body');
        this.passedWaypointsTimeSwitch = document.querySelector('.js-runner-passed-waypoints-time-switch');

        this.mapContainer = document.querySelector('.js-race-tracking-map-container');
        this.finishTemplate = document.querySelector('.js-race-tracking-finish-template');
    }

    renderFavoriteRunner(favoriteRunner: Runner) {
        if (!this.favoriteRunnerName) return;

        this.favoriteRunnerName.innerHTML = favoriteRunner.getFullName();
        this.favoriteRunnerStartnumber.innerHTML = favoriteRunner.startNumber;
        const humanReadableRun = this.runProvider.translate(RUNS_HUMAN_READABLE[favoriteRunner.run]);
        this.favoriteRunnerRun.innerHTML = `${humanReadableRun} ${favoriteRunner.year}`;
        this.favoriteRunnerTitle.innerHTML = '';

        if (favoriteRunner.profilePictureUrl) {
            this.favoriteRunnerImg.classList.remove('hidden');
            this.favoriteRunnerImg.src = favoriteRunner.profilePictureUrl;
        } else {
            this.favoriteRunnerImg.classList.add('hidden');
        }

        if (favoriteRunner.isRunRelay()) {
            [0, 1, 2, 3].forEach((relayPosition) => {
                const span: HTMLSpanElement = document.createElement('span');
                span.innerHTML = favoriteRunner.getFullName(relayPosition);

                this.favoriteRunnerTitle.append(span);
            });
        } else if (favoriteRunner.clubName) {
            this.favoriteRunnerTitle.innerHTML = favoriteRunner.clubName;
        }

        if (favoriteRunner.hasFinished() && favoriteRunner.hasRankTotal()) {
            this.favoriteRunnerRanks.classList.remove('hidden');
            this.favoriteRunnerRankTotal.innerHTML = favoriteRunner.rankTotal.toString();

            if (favoriteRunner.hasRankAge()) {
                this.favoriteRunnerRankAge.classList.remove('hidden');
                this.favoriteRunnerRankAge.innerHTML = this.favoriteRunnerRankAge.innerHTML
                    .replace('%ageGroup%', favoriteRunner.getAgeGroupString())
                    .replace('%rankAge%', favoriteRunner.rankAge.toString());
            } else {
                this.favoriteRunnerRankAge.classList.add('hidden');
            }
        } else {
            this.favoriteRunnerRanks.classList.add('hidden');
        }

        this.hideSearchContext();
    }

    showSearchContext() {
        if (!this.favoriteRunnerContainer) return;

        this.favoriteRunnerContainer.classList.add('hidden');
        this.searchToggleButton.classList.add('hidden');
        this.searchContainer.classList.remove('hidden');
    }

    hideSearchContext() {
        if (!this.searchResults) return;

        this.searchResults.innerHTML = '';
        this.searchResults.classList.add('hidden');
        this.favoriteRunnerContainer.classList.remove('hidden');
        this.searchToggleButton.classList.remove('hidden');
        this.searchContainer.classList.add('hidden');
    }

    compileSearchResultItem(runner: Runner, onSelect: (event: Event) => void): Element {
        const item = document.createElement('button');
        item.className = 'race-tracking__search-results-item';
        item.innerText = runner.getFullName();
        item.dataset.startNumber = runner.startNumber;
        item.addEventListener('click', onSelect.bind(this), {once: true});

        return item;
    }

    renderSearchResultsDropdown(runners: Array<RunnerInterface>, onSelect: (event: Event) => void) {
        if (!this.searchResults) return;

        const suggestions = runners.map((runner) => this.compileSearchResultItem(
            new Runner(runner),
            (event: Event) => {
                onSelect(event);
                this.hideSearchContext();
            },
        ));

        this.searchResults.innerHTML = '';
        this.searchResults.append(...suggestions);

        if (suggestions.length) {
            this.searchResults.classList.remove('hidden');
        } else {
            this.searchResults.classList.add('hidden');
        }
    }

    showLoader() {
        this.loadingContainer.classList.add('is-loading');
    }

    hideLoader() {
        this.loadingContainer.classList.remove('is-loading');
    }

    showFinishScreen() {
        const finishScreen = this.finishTemplate.innerHTML;
        this.mapContainer.insertAdjacentHTML('beforeend', finishScreen);
    }

    hideFinishScreen() {
        const finishScreen = this.mapContainer.querySelector('.js-race-tracking-finish-screen');
        if (finishScreen) {
            this.mapContainer.removeChild(finishScreen);
        }
    }
}
